import { render, staticRenderFns } from "./GiftBoxDetail.vue?vue&type=template&id=5ec9b4b6&scoped=true"
import script from "./GiftBoxDetail.vue?vue&type=script&lang=js"
export * from "./GiftBoxDetail.vue?vue&type=script&lang=js"
import style0 from "./GiftBoxDetail.vue?vue&type=style&index=0&id=5ec9b4b6&prod&lang=scss&scoped=true"
import style1 from "./GiftBoxDetail.vue?vue&type=style&index=1&id=5ec9b4b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec9b4b6",
  null
  
)

export default component.exports